import { Card, CaptionedImage, ClassicCard, ControlCard, ImageOnly } from "../index.js";
import { dateFromUnixTimestamp as V, rehydrateDateAfterJsonization as Y } from "../../util/date-utils.js";
import { logger as E } from "../../../shared-lib/index.js";
export function newCard(e, n, r, t, i, o, l, u, d, a, f, s, w, m, p, C, c, x) {
  var j;
  if (n === Card.es.oi || n === Card.es.ai) j = new ClassicCard(e, r, t, i, o, l, u, d, a, f, s, w, m, p, c, x);else if (n === Card.es.hs) j = new CaptionedImage(e, r, t, i, o, l, u, d, a, f, s, w, m, p, c, x);else if (n === Card.es.Ii) j = new ImageOnly(e, r, i, l, u, d, f, s, w, m, p, c, x);else {
    if (n !== Card.es.Ni) return E.error("Ignoring card with unknown type " + n), null;
    j = new ControlCard(e, r, l, u, s, w);
  }
  return C && (j.test = C), j;
}
export function newCardFromContentCardsJson(e) {
  if (e[Card.ui.Ei]) return null;
  var n = e[Card.ui.rs],
    r = e[Card.ui.ts],
    t = e[Card.ui.os],
    i = e[Card.ui.cs],
    o = e[Card.ui.ns],
    l = e[Card.ui.ds],
    u = V(e[Card.ui.ps]);
  var d;
  d = e[Card.ui.us] === Card.Ti ? null : V(e[Card.ui.us]);
  return newCard(n, r, t, i, o, l, u, d, e[Card.ui.URL], e[Card.ui.ls], e[Card.ui.fs], e[Card.ui.xs], e[Card.ui.bs], e[Card.ui.gs], e[Card.ui.js], e[Card.ui.qs] || !1, e[Card.ui.zs], e[Card.ui.ks]);
}
export function newCardFromSerializedValue(e) {
  return newCard(e[Card.ss.rs], e[Card.ss.ts], e[Card.ss.os], e[Card.ss.cs], e[Card.ss.ns], e[Card.ss.ds], Y(e[Card.ss.ps]), Y(e[Card.ss.us]), e[Card.ss.URL], e[Card.ss.ls], e[Card.ss.fs], e[Card.ss.xs], e[Card.ss.bs], e[Card.ss.gs], e[Card.ss.js], e[Card.ss.qs] || !1, e[Card.ss.zs], e[Card.ss.ks]) || void 0;
}